import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  Container,
  Form,
  Row,
  Button,
  Modal,
  Spinner,
  Alert,
} from "react-bootstrap";
import { DeleteModal } from "Common/DeleteModal";
import AgentInfo from "./AgentInfo";
import { PatternFormat } from "react-number-format";
import {
  getAgentGridList as onGetAgentGridList,
  addAgentGridList as addAgentGridListApi,
  deleteAgentGridList as onDeleteAgentGridList,
} from "slices/realestate/thunk";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { createSelector } from "reselect";
import Dropzone from "react-dropzone";
import { useFormik } from "formik";
import * as Yup from "yup";
import { createPropertyOwner, getPropertyOwners } from "../../../slices/thunk";
import { useTranslation } from "react-i18next";


const PropertyOwnerGrid = () => {
  document.title = "Property Owner";
  const { t } = useTranslation(); // ✅ React knows to update


  const dispatch = useDispatch<any>();

  const selectAgentgridList = createSelector(
    (state: any) => state.RealEstateRelibuild.propertyOwner,
    (propertyOwner) => propertyOwner
  );

  const { propertyOwner } = useSelector((state: any) => ({
    propertyOwner: selectAgentgridList(state),
  }));

  useEffect(() => {
    dispatch(getPropertyOwners());
  }, [dispatch]);

  const [gridView, setGridView] = useState<any>([]);
  const [show, setShow] = useState<boolean>(false);
  const [agentGrid, setAgentGrid] = useState<any>(null);
  const [addagent, setAddagent] = useState<boolean>(false);
  const [loading, setLoading] = useState<any>(false);
  const [editagent, setEditagent] = useState<boolean>(false);
  const [selectfeils, setSelectfeils] = useState<any>([]);
  const [notification, setNotification] = useState<{
    status: boolean;
    message: string;
    variant: "success" | "danger" | "warning" | "info";
  } | null>(null);

  //add agent modal
  const handleShowAgent = () => setAddagent(true);
  const handleCloseAgent = () => {
    setAddagent(false);
    setSelectfeils(null);
  };

  //search
  const handlesearch = (ele: any) => {
    let search = ele.target.value;
    if (search) {
      setGridView(
        propertyOwner?.filter((data: any) =>
          data.po_name.toLowerCase().includes(search.toLowerCase())
        )
      );
    } else {
      setGridView(propertyOwner);
    }
  };

  const handleselect = (ele: any) => {
    setGridView(
      propertyOwner?.filter(
        (select: any) => select.po_is_active === ele || ele === "All"
      )
    );
  };

  const handleDeleteShow = (ele: any) => {
    setShow(true);
    setAgentGrid(ele);
  };
  const handleDeleteClose = () => setShow(false);

  //delete modal
  const deleteModalFunction = () => {
    if (agentGrid.id) {
      dispatch(onDeleteAgentGridList(agentGrid.id));
    }
    setShow(false);
  };

  useEffect(() => {
    setGridView(propertyOwner);
  }, [propertyOwner]);

  const handleAcceptfiles = (files: any) => {
    const newImages = files?.map((file: any) => {
      return Object.assign(file, {
        priview: URL.createObjectURL(file),
      });
    });
    setSelectfeils([...selectfeils, ...newImages]);
  };

  const formik: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      id: (agentGrid && agentGrid.po_id) || "",
      img: (agentGrid && JSON.parse(agentGrid.po_profile_pic)[0]) || "",
      name: (agentGrid && agentGrid.po_name) || "",
      email: (agentGrid && agentGrid.po_email) || "",
      contact: (agentGrid && agentGrid.po_phone) || "",
      status: (agentGrid && agentGrid.po_is_active) || "",
      location: (agentGrid && agentGrid.po_address) || "",
      state: (agentGrid && agentGrid.po_state) || "",
      zip: (agentGrid && agentGrid.po_zip) || "",
      country: (agentGrid && agentGrid.po_country) || "",
      altContact: (agentGrid && agentGrid.po_alt_phone) || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Your Owner Name"),
      email: Yup.string()
        .email()
        .matches(/^(?!.*@[^,]*,)/)
        .required("Please Enter Your Owner Email"),
      contact: Yup.string().required("Please Enter Your Owner contact"),
      status: Yup.string().required("Please Enter Your Status"),
      location: Yup.string().required("Please Enter Your Location"),
      img: Yup.mixed().required("Please Enter Your Image"),
      state: Yup.string().required("Please Enter Your State"),
      zip: Yup.string().required("Please Enter Your Zip"),
      country: Yup.string().required("Please Enter Your Country"),
    }),
    onSubmit: (values: any) => {
      setLoading(true);
      if (editagent) {
        const formData = {
          ...values,
        };
        dispatch(createPropertyOwner(formData));
        dispatch(getPropertyOwners());
        setLoading(false);
        setNotification({
          status: true,
          message: "Property Owner Updated Successfully",
          variant: "success",
        });
        formik.resetForm();
      } else {
        setLoading(true);
        const formData = {
          ...values,
        };
        dispatch(createPropertyOwner(formData));
        dispatch(getPropertyOwners());
        setLoading(false);
        setNotification({
          status: true,
          message: "Property Owner Created Successfully",
          variant: "success",
        });
        formik.resetForm();
      }

      if (values === null) {
        handleShowAgent();
      } else {
        handleCloseAgent();
      }
    },
  });

  const handleAlertClick = () => {
    setNotification(null);
  };

  return (
<React.Fragment>
      {notification && notification.status && (
        <div
          style={{
            position: "absolute",
            top: "5%",
            right: "24px",
            zIndex: 99999,
          }}
        >
          
          <Alert variant={notification.variant} onClick={handleAlertClick}>
            {t(notification.message)}
          </Alert>
        </div>
      )}
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "200px" }}
        >
          <Spinner animation="border" role="status">
            <span className="visually-hidden">{t("Loading...")}</span>
          </Spinner>
        </div>
      ) : (
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col lg={12}>
                <Card>
                  <Card.Body>
                    <Row className="align-items-center gy-3">
                      <Col
                        lg={3}
                        md={6}
                        className="order-last order-md-first me-auto"
                      >
                        <div className="search-box">
                          <Form.Control
                            type="text"
                            autoComplete="off"
                            id="searchResultList"
                            placeholder={t("Search for property owners")}
                            onChange={(e: any) => handlesearch(e)}
                          />
                          <i className="ri-search-line search-icon"></i>
                        </div>
                      </Col>
                      <Col xl={2} lg={3} sx={12}>
                        <div>
                          <Form.Select
                            id="status-input"
                            onClick={(e: any) => handleselect(e.target.value)}
                          >
                            <option value="All">{t("Select status")}</option>
                            <option value="Active">{t("Active")}</option>
                            <option value="Unactive">{t("Unactive")}</option>
                          </Form.Select>
                        </div>
                      </Col>
                      <Col className="col-auto text-end">
                        <Button variant="secondary" onClick={handleShowAgent}>
                          <i className="bi bi-person-plus align-baseline me-1"></i>{" "}
                          {t("Add Property Owner")}
                        </Button>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <AgentInfo
              data={gridView}
              rowclassname="row-cols-xxl-5 row-cols-md-2 row-cols-1"
              perPageData={10}
              handleDeleteShow={handleDeleteShow}
            />
          </Container>
        </div>
      )}
      <Modal show={addagent} onHide={handleCloseAgent}>
        <Modal.Header closeButton>
          <Modal.Title as="h5" id="addAgentModalLabel">
            {t(editagent ? "Edit Property Owner" : "Add Property Owner")}
          </Modal.Title>
        </Modal.Header>
        <Form
          className="tablelist-form"
          autoComplete="off"
          onSubmit={formik.handleSubmit}
        >
          <Modal.Body>
            <div className="mb-3">
              <Form.Label>
                {t("Property Owner Images")}<span className="text-danger">*</span>
              </Form.Label>
              <Dropzone
                onDrop={(acceptfiles: any) => {
                  handleAcceptfiles(acceptfiles);
                  formik.setFieldValue("img", acceptfiles);
                }}
                name="img"
                value={formik.values.img || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={!!formik.errors.img}
              >
                {({ getRootProps }: any) => (
                  <div
                    className="sellers-dropzone text-center dz-clickable"
                    style={{ minHeight: "180px" }}
                  >
                    <div className="dz-message needsclick" {...getRootProps()}>
                      <div className="mb-3">
                        <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                      </div>
                      <h5>{t("Drop files here or click to upload.")}</h5>
                    </div>
                  </div>
                )}
              </Dropzone>
              {formik.errors.img && formik.touched.img ? (
                <Form.Control.Feedback type="invalid" className="d-block">
                  {t(formik.errors.img)}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-ghost-danger"
              onClick={handleCloseAgent}
            >
              <i className="bi bi-x-lg align-baseline me-1"></i> {t("Close")} 
            </Button>
            <Button type="submit" variant="primary" id="add-btn">
              {t(editagent ? "Edit" : "Add")}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <DeleteModal
        show={show}
        handleClose={handleDeleteClose}
        deleteModalFunction={deleteModalFunction}
      />
      <ToastContainer />
    </React.Fragment>

  );
};

export default PropertyOwnerGrid;
